/**
 * 授权检查
 * @author Caesar Liu
 * @date 2019/3/26 14:58
 */

import request from '../utils/request'

/**
 * 登录授权检查
 */
export function checkLogin (appId, redirectUri, digest) {
  return request.post('/digest/check/login', {
    appId,
    redirectUri,
    digest
  })
}

/**
 * 设置密码授权检查
 */
export function checkSetPwd (secure, timestamp, digest) {
  return request.post('/digest/check/setpwd', {
    secure,
    timestamp,
    digest
  })
}
